import React from 'react';

/** The browser's own range input: it moves freely in small steps (owner 2026-09-29). */
export default function UsageSlider({value, max, step, onChange, label}) {
  return (
    <input
      type="range"
      aria-label={label}
      min={0}
      max={max}
      step={step}
      value={value}
      onChange={event => onChange(Number(event.target.value))}
      style={{width: '100%', marginTop: 10, accentColor: '#C5E836', cursor: 'pointer'}}
    />
  );
}
